export default class Clipboard {
  static copyToClipboard(content, _document) {
    // "document" is mandatory, in order to avoid specs timeout
    const ghostEl = _document.createElement('textarea');
    ghostEl.style.left = '-9999px';
    ghostEl.value = content;
    _document.body.appendChild(ghostEl);
    ghostEl.select();
    _document.execCommand('copy');
    ghostEl.remove();
  }
}
